import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { DispatcherService } from '@frontend/sports/common/core/utils/dispatcher';
import { ActiveModal } from '@frontend/sports/modal/feature';
import { DsButton } from '@frontend/ui/button';
import { Store } from '@ngrx/store';
import BetslipPickActions from 'packages/sports/common/betslip/modules/picks/actions';

@Component({
    imports: [NgIf, NgFor, NgClass, DsButton],
    providers: [DispatcherService],
    selector: 'ms-clear-betslip',
    templateUrl: './clear-betslip.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClearBetslipComponent {
    constructor(
        private activeModal: ActiveModal,
        private store: Store,
        public sitecoreData: Sitecore,
    ) {}

    isBetslipCleared = false;

    onClose(): void {
        this.activeModal.close();
    }

    onClearBetslip(): void {
        this.store.dispatch(BetslipPickActions.requestRemoveAllPicks());
        this.isBetslipCleared = true;
    }
}
